var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid h-100"},[_c('div',{staticClass:"row h-100 align-items-center"},[_c('div',{staticClass:"col"},[_c('h5',{staticClass:"text-center text-success"},[_c('router-link',{attrs:{"to":"/userpanel"}},[_vm._v("برای ورود به پنل اینجا را کلیک نمایید")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }